module.exports = __webpack_public_path__ + "static/img/thum2.5ff723f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/thum2.png
// module id = 8THI
// module chunks = 1